<template>
  <div class="container py-2">

    <div class="status-wrapper">

      <div class="status-header">
        <h3>Status Pelanggaran</h3>
        <p class="instruction-text">
          Informasi status data pelanggaran yang ditemukan.
        </p>
      </div>

      <div class="table-responsive">

        <table class="modern-table">

          <tbody>

            <tr class="section-row">
              <td colspan="2">
                Bukti Pelanggaran
              </td>
            </tr>

            <tr>
              <th>Media Foto / Video</th>

              <td>

                <div class="tabs">

                  <button type="button" class="tab-btn" :class="{ active: activeTab === 'foto' }"
                    @click="activeTab = 'foto'">
                    Foto Bukti
                  </button>

                  <button v-if="videoUrl" type="button" class="tab-btn" :class="{ active: activeTab === 'video' }"
                    @click="activeTab = 'video'">
                    Video Bukti
                  </button>

                </div>

              </td>
            </tr>

            <tr v-if="
              activeTab === 'foto' ||
              (activeTab === 'video' && videoUrl)
            ">

              <td colspan="2" class="media-full-cell">

                <div v-if="activeTab === 'foto'" class="media-box-full">

                  <div v-if="imgSrc" class="image-overlay-container">

                    <img :src="imgSrc" class="fullFrame-view" @error="onImgError" alt="Bukti Foto Pelanggaran" />

                    <div class="overlay-top-bar">

                      <span class="label">
                        Tanggal dan Jam :
                      </span>

                      <span class="value">
                        {{ statusData?.waktu || '-' }}
                      </span>

                    </div>

                    <div v-if="reportType === 'DOKUMEN'" class="overlay-data-box overlay-dokumen">

                      <div class="data-header">
                        DOKUMEN / KIR
                      </div>

                      <div class="data-body">

                        <div class="data-row">

                          <span class="data-label">
                            TNKB
                          </span>

                          <span class="data-separator">
                            :
                          </span>

                          <span class="data-value">
                            {{ statusData?.plat || '-' }}
                          </span>

                        </div>


                        <div class="data-row">

                          <span class="data-label">
                            Uji KIR
                          </span>

                          <span class="data-separator">
                            :
                          </span>

                          <span class="data-value">
                            {{ statusData?.tgl_uji_kir || '-' }}
                          </span>

                        </div>

                        <div class="data-row">

                          <span class="data-label">
                            Berlaku KIR
                          </span>

                          <span class="data-separator">
                            :
                          </span>

                          <span class="data-value">
                            {{
                              statusData?.tanggal_masa_berlaku ||
                              statusData?.masa_berlaku ||
                              '-'
                            }}
                          </span>

                        </div>


                        <div class="data-row">

                          <span class="data-label">
                            Status KIR
                          </span>

                          <span class="data-separator">
                            :
                          </span>

                          <span class="data-value" :class="{
                            'status-expired':
                              normalizeValue(statusData?.kir_status) === 'habis'
                          }">
                            {{ statusData?.kir_status || '-' }}
                          </span>

                        </div>

                      </div>

                    </div>

                    <div v-else-if="isOverload" class="overlay-data-box overlay-overload">

                      <div class="data-header">
                        OVER LOAD
                      </div>

                      <div class="data-body">

                        <div class="data-row">
                          <span class="data-label">
                            {{ isMobilPenarik ? 'JBKB' : 'JBI' }}
                          </span>

                          <span class="data-separator">:</span>

                          <span class="data-value">
                            {{ statusData?.jbi || '-' }}
                          </span>
                        </div>


                        <div class="data-row">

                          <span class="data-label">
                            Berat Timbang
                          </span>

                          <span class="data-separator">
                            :
                          </span>

                          <span class="data-value">
                            {{ statusData?.berat_timbang || '-' }}
                          </span>

                        </div>


                        <div class="data-row">

                          <span class="data-label">
                            Berat Lebih
                          </span>

                          <span class="data-separator">
                            :
                          </span>

                          <span class="data-value">
                            {{ statusData?.berat_lebih || '-' }}
                          </span>

                        </div>


                        <div v-if="statusData?.berat_lebih_persen" class="data-row">

                          <span class="data-label">
                            Persentase
                          </span>

                          <span class="data-separator">
                            :
                          </span>

                          <span class="data-value">
                            {{ statusData.berat_lebih_persen }}%
                          </span>

                        </div>

                      </div>

                    </div>

                    <div v-else-if="reportType" class="overlay-data-box overlay-default">

                      <div class="data-header">
                        {{ reportType }}
                      </div>

                      <div class="data-body">

                        <div class="data-row">

                          <span class="data-label">
                            Jenis
                          </span>

                          <span class="data-separator">
                            :
                          </span>

                          <span class="data-value">
                            {{ reportType }}
                          </span>

                        </div>

                      </div>

                    </div>

                  </div>

                  <div v-else class="no-media-alert">

                    <p class="m-0">
                      Tidak ada foto bukti.
                    </p>

                  </div>

                </div>

                <div v-if="activeTab === 'video' && videoUrl" class="media-box-full">

                  <video controls class="fullFrame-view">

                    <source :src="videoUrl" type="video/mp4" />

                    Browser Anda tidak mendukung tag video.

                  </video>

                </div>

              </td>

            </tr>

            <tr>
              <th>No. Registrasi</th>

              <td>
                {{ statusData?.noref || '-' }}
              </td>
            </tr>


            <tr>
              <th>No. TNKB</th>

              <td>
                {{ statusData?.plat || '-' }}
              </td>
            </tr>


            <tr>
              <th>Tanggal dan Jam</th>

              <td>
                {{ statusData?.waktu || '-' }}
              </td>
            </tr>

            <tr class="section-row">
              <td colspan="2">
                Lokasi & Pelanggaran
              </td>
            </tr>


            <tr>
              <th>Lokasi</th>

              <td>
                {{ statusData?.jalan || '-' }}
              </td>
            </tr>


            <tr>
              <th>Jenis Pelanggaran</th>

              <td>
                {{ jenisPelanggaran || '-' }}
              </td>
            </tr>


            <tr>
              <th>Pasal Pelanggaran</th>

              <td>
                {{ pasalList || '-' }}
              </td>
            </tr>

            <tr class="section-row">
              <td colspan="2">
                Data Pemilik
              </td>
            </tr>


            <tr>
              <th>Pemilik Kendaraan</th>

              <td>
                {{ statusData?.NamaPemilik || '-' }}
              </td>
            </tr>


            <tr>
              <th>Alamat Pemilik</th>

              <td>
                {{ statusData?.Alamat || '-' }}
              </td>
            </tr>

            <tr class="section-row">
              <td colspan="2">
                Data Kendaraan
              </td>
            </tr>


            <tr>
              <th>TNKB / Plat Nomor</th>

              <td>
                <strong>
                  {{ statusData?.plat || '-' }}
                </strong>
              </td>
            </tr>


            <tr>
              <th>Tahun Kendaraan</th>

              <td>
                {{ statusData?.tahun || '-' }}
              </td>
            </tr>


            <tr>
              <th>Warna</th>

              <td>
                {{ statusData?.warna || '-' }}
              </td>
            </tr>


            <tr>
              <th>Merk</th>

              <td>
                {{ statusData?.merk || '-' }}
              </td>
            </tr>


            <tr>
              <th>Jenis Kendaraan</th>

              <td>
                {{ statusData?.model || '-' }}
              </td>
            </tr>


            <tr>
              <th>Tipe Kendaraan</th>

              <td>
                {{ statusData?.tipe_regident || '-' }}
              </td>
            </tr>


            <tr>
              <th>No. Mesin</th>

              <td>
                {{ statusData?.no_mesin || '-' }}
              </td>
            </tr>


            <tr>
              <th>No. Rangka</th>

              <td>
                {{ statusData?.no_rangka || '-' }}
              </td>
            </tr>


            <tr>
              <th>Tanggal Uji KIR</th>

              <td>
                {{
                  statusData?.tgl_uji_kir ||
                  statusData?.tgl_uji ||
                  '-'
                }}
              </td>
            </tr>


            <tr>
              <th>Masa Berlaku KIR</th>

              <td>
                {{
                  statusData?.tanggal_masa_berlaku ||
                  statusData?.masa_berlaku ||
                  '-'
                }}
              </td>
            </tr>


            <tr>
              <th>{{ isMobilPenarik ? 'JBKB' : 'JBI' }}</th>

              <td>
                {{ statusData?.jbi || '-' }}
              </td>
            </tr>


            <tr>
              <th>Berat Timbang</th>

              <td>
                {{ statusData?.berat_timbang || '-' }}
              </td>
            </tr>


            <tr>
              <th>Berat Lebih</th>

              <td>
                {{ statusData?.berat_lebih || '-' }}
              </td>
            </tr>

          </tbody>

        </table>

      </div>

      <div class="action-group">

        <button type="button" class="btn-back" @click="$emit('prev')">

          <i class="bi bi-arrow-left"></i>

          Kembali

        </button>


        <button type="button" class="btn-next" @click="goToNextStep">

          Lanjut

          <i class="bi bi-arrow-right"></i>

        </button>

      </div>

    </div>

  </div>
</template>


<script>
import { postDetailsKonfirmasi } from "./api";
import Swal from "sweetalert2";

export default {

  props: {

    noReferensi: String,

    noPolisi: String,

    pelanggaranData: Array,

  },


  data() {

    return {

      statusData: null,

      pasalList: "",

      jenisPelanggaran: "",

      imgSrc: null,

      videoUrl: null,

      activeTab: "foto",

    };

  },


  async mounted() {

    if (
      this.pelanggaranData &&
      this.pelanggaranData.length > 0
    ) {

      this.statusData = this.pelanggaranData[0];

      this.setMediaUrls();

      this.initDataDisplay();

    } else {

      await this.checkStatus();

    }

  },


  computed: {

    reportType() {

      if (!this.statusData) {
        return "";
      }

      return String(
        this.statusData.report_type || ""
      )
        .trim()
        .toUpperCase();

    },

    isMobilPenarik() {
      return String(this.statusData?.model || '')
        .trim()
        .toUpperCase()
        .includes('MOBIL PENARIK');
    },

    isOverload() {

      const type = this.reportType;

      const overloadTypes = [
        "OVERLOAD",
        "ANGKUT",
        "DAYA",
        "DAYA ANGKUT",
        "ANGKUT/OVERLOAD/DAYA"
      ];

      if (overloadTypes.includes(type)) {
        return true;
      }

      if (!type && this.statusData) {

        const candidates = [

          this.statusData.report_type_code_array,

          this.statusData.jenis_pelanggaran,

          this.statusData.tipe_pelanggaran,

          this.statusData.violation_type,

          this.statusData.violation_type_name

        ];


        const normalized = candidates

          .filter(
            value =>
              value !== null &&
              value !== undefined
          )

          .map(
            value =>
              String(value)
                .toLowerCase()
                .replace(/[\s_\-/]+/g, "")
          );


        return normalized.some(value =>

          value.includes("overload") ||

          value.includes("dayaangkut") ||

          value === "angkut"

        );

      }


      return false;

    },

  },


  methods: {


    normalizeValue(value) {

      if (
        value === null ||
        value === undefined
      ) {

        return "";

      }

      return String(value)
        .trim()
        .toLowerCase();

    },

    initDataDisplay() {

      if (!this.statusData) {
        return;
      }


      this.setMediaUrls();


      const type1 =
        this.statusData.report_type;

      const type2 =
        this.statusData.report_type_code_array;


      this.jenisPelanggaran = [

        type1,

        type2

      ]

        .filter(

          val =>

            val !== null &&

            val !== undefined &&

            String(val).trim() !== "" &&

            String(val).toLowerCase() !== "null"

        )

        .join(", ");


      this.pasalList =
        this.statusData.pasal || "";

    },


    /* =========================================================
       GET STATUS
    ========================================================== */

    async checkStatus() {

      try {

        const formData =
          new FormData();


        formData.append(
          "no_ref",
          this.noReferensi
        );


        formData.append(
          "no_plat",
          this.noPolisi
        );


        const response =
          await postDetailsKonfirmasi(
            formData
          );


        this.statusData =
          response.data &&
            response.data.length > 0
            ? response.data[0]
            : null;


        this.setMediaUrls();

        this.initDataDisplay();

      }

      catch (error) {

        Swal.fire({

          title: "Kesalahan!",

          text:
            "Terjadi kesalahan saat memeriksa status pelanggaran.",

          icon: "error",

          confirmButtonColor: "#2563eb"

        });


        console.error(
          "Error fetching status:",
          error
        );

      }

    },

    setMediaUrls() {

      if (!this.statusData) {
        return;
      }


      if (

        this.statusData.local_photo &&

        this.statusData.local_photo !== "null"

      ) {

        this.imgSrc =
          "https://api-etle.polri.go.id/pelanggaran/img/" +
          this.statusData.local_photo;

      }

      else if (
        this.statusData.bukti_foto
      ) {

        this.imgSrc =
          this.statusData.bukti_foto;

      }

      else {

        this.imgSrc = null;

      }


      this.videoUrl =

        this.statusData.bukti_video &&

          this.statusData.bukti_video !== "null"

          ? this.statusData.bukti_video

          : null;

    },


    onImgError() {

      this.imgSrc = null;

    },


    goToNextStep() {

      const nextData = {

        noReferensi:
          this.noReferensi,

        noPolisi:
          this.noPolisi,

        pelanggaranData:
          this.statusData
            ? [this.statusData]
            : null,

      };


      this.$emit(
        "next",
        nextData
      );

    },

  },

};
</script>


<style>
.status-wrapper {

  background: #fff;

  padding: 35px;

  border-radius: 16px;

  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.05);

}


.status-header {

  margin-bottom: 30px;

}


.status-header h3 {

  font-size: 28px;

  font-weight: 600;

  color: #0f2f5f;

  margin-bottom: 10px;

}


.instruction-text {

  color: #64748b;

  font-size: 16px;

  margin-bottom: 0;

}


.modern-table {

  width: 100%;

  border-collapse: separate;

  border-spacing: 0 12px;

}


.modern-table th {

  width: 260px;

  text-align: left;

  padding: 16px 20px;

  font-weight: 500;

  font-size: 16px;

  color: #1e293b;

  background: #f1f5fb;

  border-radius: 10px 0 0 10px;

  border-left: 1px solid #cbd5e1;

  border-top: 1px solid #cbd5e1;

  border-bottom: 1px solid #cbd5e1;

}


.modern-table td {

  padding: 16px 20px;

  background: #ffffff;

  border-radius: 0 10px 10px 0;

  font-size: 16px;

  color: #0f172a;

  border-right: 1px solid #cbd5e1;

  border-top: 1px solid #cbd5e1;

  border-bottom: 1px solid #cbd5e1;

  box-shadow:
    0 2px 5px rgba(15, 23, 42, 0.02);

}


.section-row td {

  background: transparent !important;

  box-shadow: none !important;

  border: none !important;

  font-weight: 600;

  color: #0f2f5f;

  padding: 24px 0 8px 5px;

  font-size: 15px;

  text-transform: uppercase;

  letter-spacing: 1px;

}


.tabs {

  display: flex;

  gap: 10px;

}


.action-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  margin-top: 30px;
  padding-top: 10px;
}

.btn-back,
.btn-next {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 46px;
  padding: 11px 22px;
  border-radius: 8px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-back {
  background: #ffffff;
  color: #334155;
  border: 1px solid #cbd5e1;
  box-shadow: 0 2px 5px rgba(15, 23, 42, 0.05);
}

.btn-back:hover {
  background: #f8fafc;
  border-color: #94a3b8;
  color: #1e293b;
  transform: translateY(-1px);
}

.btn-back:active {
  transform: translateY(0);
}

.btn-next {
  background: #2563eb;
  color: #ffffff;
  border: 1px solid #2563eb;
  box-shadow: 0 3px 8px rgba(37, 99, 235, 0.2);
}

.btn-next:hover {
  background: #1d4ed8;
  border-color: #1d4ed8;
  color: #ffffff;
  transform: translateY(-1px);
  box-shadow: 0 5px 12px rgba(37, 99, 235, 0.25);
}

.btn-next:active {
  transform: translateY(0);
}

.btn-back i,
.btn-next i {
  font-size: 16px;
  line-height: 1;
}


@media (max-width: 768px) {

  .action-group {
    gap: 10px;
    margin-top: 25px;
  }

  .btn-back,
  .btn-next {
    flex: 1;
    min-height: 44px;
    padding: 10px 16px;
    font-size: 14px;
  }

  .btn-back i,
  .btn-next i {
    font-size: 15px;
  }
}


.tab-btn {

  padding: 10px 20px;

  background-color: #f1f5f9;

  border: 1px solid #cbd5e1;

  border-radius: 8px;

  color: #1e293b;

  font-size: 15px;

  cursor: pointer;

  transition: all 0.2s;

}


.tab-btn:hover {

  background-color: #e2e8f0;

}


.tab-btn.active {

  background-color: #2563eb;

  border-color: #2563eb;

  color: white;

  font-weight: 500;

}


.media-full-cell {

  background: #f8fafc !important;

  padding: 20px !important;

  border: 1px solid #cbd5e1 !important;

  border-radius: 12px !important;

}


.media-box-full {

  width: 100%;

  display: flex;

  justify-content: center;

  align-items: center;

}


.fullFrame-view {

  width: 100%;

  max-width: 100%;

  height: auto;

  display: block;

  object-fit: contain;

}


.no-media-alert {

  width: 100%;

  padding: 40px;

  text-align: center;

  background: #ffffff;

  border: 2px dashed #cbd5e1;

  border-radius: 10px;

  font-size: 16px;

  color: #64748b;

}

.image-overlay-container {

  position: relative;

  display: inline-block;

  width: 100%;

  max-width: 100%;

  overflow: hidden;

  vertical-align: top;

  border-radius: 10px;

  border: 3px solid #cbd5e1;

  box-shadow:
    0 4px 12px rgba(15, 23, 42, 0.08);

}

.overlay-top-bar {

  position: absolute;

  top: 0;

  left: 0;

  width: 100%;

  background-color:
    rgba(0, 0, 0, 0.75);

  color: white;

  box-sizing: border-box;

  padding: 10px 15px;

  font-family:
    'Courier New',
    Courier,
    monospace;

  font-size: 14px;

  line-height: 1.4;

  display: flex;

  gap: 10px;

  flex-wrap: wrap;

  border-bottom:
    2px solid #2563eb;

  z-index: 10;

}


.overlay-top-bar .label {

  font-weight: bold;

}

.overlay-data-box {

  position: absolute;

  bottom: 15px;

  right: 15px;

  box-sizing: border-box;

  width: min(360px,
      calc(100% - 30px));

  max-width:
    calc(100% - 30px);

  background-color:
    rgba(0, 0, 0, 0.88);

  color: white;

  border-radius: 8px;

  overflow: hidden;

  font-family:
    'Courier New',
    Courier,
    monospace;

  z-index: 10;

  box-shadow:
    0 4px 10px rgba(0, 0, 0, 0.5);

}

.overlay-dokumen {

  border:
    2px solid #2563eb;

}


.overlay-dokumen .data-header {

  background-color:
    rgba(37, 99, 235, 0.25);

  color: #60a5fa;

  border-bottom:
    1px solid #2563eb;

}

.overlay-overload {

  border:
    2px solid #f97316;

}


.overlay-overload .data-header {

  background-color:
    rgba(249, 115, 22, 0.25);

  color: #fb923c;

  border-bottom:
    1px solid #f97316;

}

.overlay-default {

  border:
    2px solid #64748b;

}


.overlay-default .data-header {

  background-color:
    rgba(100, 116, 139, 0.25);

  color: #cbd5e1;

  border-bottom:
    1px solid #64748b;

}

.overlay-data-box {

  position: absolute;

  bottom: 15px;

  right: 15px;

  box-sizing: border-box;

  width: min(360px,
      calc(100% - 30px));

  max-width:
    calc(100% - 30px);

  background: rgba(0, 0, 0, 0.92);

  color: #ffffff;

  border: 1px solid rgba(255, 255, 255, 0.35);

  border-radius: 6px;

  overflow: hidden;

  font-family:
    Arial,
    Helvetica,
    sans-serif;

  z-index: 10;

  box-shadow:
    0 3px 10px rgba(0, 0, 0, 0.45);

}

.overlay-data-box .data-header {

  background: #000000;

  color: #ffffff;

  padding: 9px 14px;

  font-family:
    Arial,
    Helvetica,
    sans-serif;

  font-size: 15px;

  font-weight: 700;

  text-transform: uppercase;

  border-bottom:
    1px solid rgba(255, 255, 255, 0.35);

}


.overlay-data-box .data-body {

  background: #000000;

  padding: 12px 14px;

  font-family:
    Arial,
    Helvetica,
    sans-serif;

  font-size: 13px;

  color: #ffffff;

}


.overlay-data-box .data-row {

  display: flex;

  align-items: center;

  margin-bottom: 7px;

  line-height: 1.4;

}


.overlay-data-box .data-row:last-child {

  margin-bottom: 0;

}

.overlay-data-box .data-label {

  width: 125px;

  flex-shrink: 0;

  color: #ffffff;

  font-weight: 400;

}


.overlay-data-box .data-separator {

  width: 20px;

  flex-shrink: 0;

  text-align: center;

  color: #ffffff;

  font-weight: 400;

}

.overlay-data-box .data-value {

  flex: 1;

  color: #ffffff;

  font-weight: 700;

  word-break: break-word;

}

.status-expired {

  color: #ffffff !important;

  font-weight: 700;

}


.overlay-dokumen {

  background: #000000;

  border: 1px solid rgba(255, 255, 255, 0.35);

}


.overlay-dokumen .data-header {

  background: #000000;

  color: #ffffff;

  border-bottom:
    1px solid rgba(255, 255, 255, 0.35);

}

.overlay-overload {

  background: #000000;

  border: 1px solid rgba(255, 255, 255, 0.35);

}


.overlay-overload .data-header {

  background: #000000;

  color: #ffffff;

  border-bottom:
    1px solid rgba(255, 255, 255, 0.35);

}

.overlay-default {

  background: #000000;

  border: 1px solid rgba(255, 255, 255, 0.35);

}


.overlay-default .data-header {

  background: #000000;

  color: #ffffff;

  border-bottom:
    1px solid rgba(255, 255, 255, 0.35);

}

.overlay-top-bar {

  position: absolute;

  top: 0;

  left: 0;

  width: 100%;

  box-sizing: border-box;

  background: rgba(0, 0, 0, 0.88);

  color: #ffffff;

  padding: 9px 14px;

  font-family:
    Arial,
    Helvetica,
    sans-serif;

  font-size: 14px;

  line-height: 1.4;

  display: flex;

  gap: 8px;

  flex-wrap: wrap;

  border-bottom:
    1px solid rgba(255, 255, 255, 0.35);

  z-index: 10;

}


.overlay-top-bar .label {

  color: #ffffff;

  font-weight: 700;

}


.overlay-top-bar .value {

  color: #ffffff;

  font-weight: 400;

}

@media (max-width: 768px) {

  .overlay-top-bar {

    font-size: 11px;

    padding: 6px 10px;

  }


  .overlay-data-box {

    width:
      min(320px,
        calc(100% - 20px));

    max-width:
      calc(100% - 20px);

    bottom: 10px;

    right: 10px;

    background: rgba(0, 0, 0, 0.92);

  }


  .overlay-data-box .data-header {

    font-size: 13px;

    padding: 7px 10px;

  }


  .overlay-data-box .data-body {

    padding: 9px 10px;

    font-size: 11px;

  }


  .overlay-data-box .data-label {

    width: 90px;

  }

}
</style>
